<template>
  <div
    class="segmented-list"
    :class="{
      'multi-column': segmentBy && multiColumn,
      'continuous-columns': segmentBy && continuousColumns,
      'no-segment': !segmentBy
    }"
    :style="{'grid-template-rows': `repeat(${rowCount}, auto)`}"
  >
    <div
      v-for="(group, groupLabel) in itemGroups"
      :key="groupLabel"
      class="group"
    >
      <div v-if="segmentBy" class="item header">
        {{ groupLabel }}
      </div>
      <md-button
        v-for="item in group"
        :key="item.key"
        class="item"
        :class="item.class"
        @click="onItemClick(item)"
      >
        <md-highlight-text :md-term="highlightTerm">
          {{
            item.label
          }}
        </md-highlight-text>
      </md-button>
    </div>
  </div>
</template>

<script>
import groupBy from 'lodash/groupBy';

export default {
  name: 'segmented-list',
  props: {
    items: {
      type: Array,
      required: true,
    },
    segmentBy: {
      type: String,
      default: null,
    },
    multiColumn: {
      type: Boolean,
      default: true,
    },
    highlightTerm: {
      type: String,
      default: null,
    },
    continuousColumns: {
      type: Boolean,
      default: false,
    },
    rowCount: {
      type: Number,
      default: 10,
    },
  },
  computed: {
    itemGroups() {
      const itemGroups = groupBy(this.items, this.segmentBy);
      return itemGroups;
    },
  },
  methods: {
    onItemClick(item) {
      this.$emit('click', item);
    },
  },
};
</script>

<style scoped>
.segmented-list {
  background-color: #eeeeee;
  color: #525252;
  z-index: 3001;
  min-width: 300px;
  border-radius: 3px;
}

.segmented-list {
  display: flex;
  flex-direction: column;
}

.segmented-list.multi-column {
  display: flex;
  flex-direction: row;
}

.segmented-list.multi-column.continuous-columns {
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: repeat(10, auto);
}

.segmented-list.multi-column.continuous-columns .group {
  display: contents;
}

.item {
  font-size: 20px;
  line-height: 26px;
  padding: 12px 20px;
  white-space: nowrap;
  font-weight: normal;
  height: auto;
  /* We want to set this to initial but unfortunately in prod builds
  it gets changed to min-width: 0, which combined with display: contents
  causes the items to no longer expand to fit their children */
  min-width: inherit;
  margin: 0;
  width: 100%;
  text-align: left;
  overflow: initial;
}

.header {
  font-weight: bold;
  cursor: initial;
  text-transform: uppercase;
}

.segmented-list >>> .md-highlight-text-match {
  font-weight: bold;
}

.item >>> .md-ripple {
  padding: 0;
  width: auto;
  justify-content: start;
}
</style>